export const pushViewableImpressionToDataLayer = (impressionEvent) => {
  const adParent = document.getElementById(impressionEvent.slot.getSlotElementId());
  const adChild = adParent?.getElementsByClassName('click_data_element')[0]

  if (!adChild) { return; }

  window.dataLayer.push({
    event: 'trackable event',
    eventName: 'Google viewable impression',
    eventParams: adChild.dataset,
  });
}
